import React from 'react';

interface IProps {
  playing: boolean;
}

export const PlayIcon:React.FC<IProps> = ({ playing }) => (
  <div className="myinterview-widget-icons__play-button">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="currentColor"
      viewBox="0 0 50 50"
    >
      <rect width="50" height="50" fill="#fff" rx="25" />
      <path
        fill="currentColor"
        d={!playing
          ? 'M 32 25 l -11 8 V 17 l 11 8 z M 32 25 l -11 8 V 17 l 11 8 z M 32 25 l 0 0 V 25 l 0 0 z'
          : 'M 23 32 l -6 0 V 18 l 6 0 z M 23 32 l -6 0 V 18 l 6 0 z M 34 32 l -6 0 V 18 l 6 0 z'}
      />
    </svg>
  </div>
);
